import { render, staticRenderFns } from "./applyDetail.vue?vue&type=template&id=0c6ae72e&scoped=true&"
import script from "./applyDetail.vue?vue&type=script&lang=js&"
export * from "./applyDetail.vue?vue&type=script&lang=js&"
import style0 from "./applyDetail.vue?vue&type=style&index=0&id=0c6ae72e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6ae72e",
  null
  
)

export default component.exports